const DECIMALS = 18n;
const DECIMALS_DIV = 10n ** DECIMALS;

/** Formata um valor uint256 (bigint, 18 decimais) como string SIMC legível. */
export function formatSIMC(value, { maxFrac = 4 } = {}) {
  const whole = value / DECIMALS_DIV;
  const frac = value % DECIMALS_DIV;
  if (frac === 0n) return whole.toLocaleString('pt-BR');

  const fracStr = frac.toString().padStart(18, '0').slice(0, maxFrac).replace(/0+$/, '');
  const wholeStr = whole.toLocaleString('pt-BR');
  return fracStr ? `${wholeStr},${fracStr}` : wholeStr;
}

export function shortAddress(addr) {
  if (!addr) return '';
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

export function shortHash(hash) {
  if (!hash) return '';
  return `${hash.slice(0, 8)}…${hash.slice(-6)}`;
}

/** "12s", "3min", "2h", "3d" — unidade compacta, sem prefixo "há". */
export function relativeTimeCompact(timestampMs, nowMs = Date.now()) {
  if (!timestampMs) return '—';
  const diffSec = Math.max(0, Math.round((nowMs - timestampMs) / 1000));

  if (diffSec < 60) return `${diffSec}s`;
  if (diffSec < 3600) return `${Math.round(diffSec / 60)}min`;
  if (diffSec < 86400) return `${Math.round(diffSec / 3600)}h`;
  return `${Math.round(diffSec / 86400)}d`;
}

/** "há 12s", "há 3min", "há 2h" etc a partir de um timestamp (ms). */
export function relativeTime(timestampMs, nowMs = Date.now()) {
  if (!timestampMs) return '—';
  return `há ${relativeTimeCompact(timestampMs, nowMs)}`;
}

